export function getInputFields(definition) {
    if (!definition || !Array.isArray(definition.fields))
        return [];
    return definition.fields.filter((f) => f && !["section", "description"].includes(String(f.type)));
}
export function buildFieldMap(definition) {
    const map = {};
    getInputFields(definition).forEach((field) => {
        if (field.id)
            map[field.id] = field;
    });
    return map;
}
export function resolveOptionLabel(field, optId) {
    if (!field || !Array.isArray(field.options))
        return String(optId);
    const id = String(optId);
    const found = field.options.find((opt) => String(opt.id) === id);
    return found ? found.label : id;
}
export function formatAnswerValue(field, value) {
    if (value === null || value === undefined || value === "")
        return "—";
    if (!field)
        return stringifyValue(value);
    const type = String(field.type);
    if (type === "single_choice" || type === "dropdown") {
        return resolveOptionLabel(field, value);
    }
    if (type === "multi_choice") {
        const items = Array.isArray(value) ? value : [value];
        if (!items.length)
            return "—";
        return items.map((item) => resolveOptionLabel(field, item)).join(", ");
    }
    if (type === "rating") {
        const max = field.max || 5;
        return `${value} / ${max} sao`;
    }
    if (type === "date") {
        const text = String(value);
        const d = new Date(text.replace(" ", "T"));
        if (!Number.isNaN(d.getTime())) {
            return d.toLocaleDateString("vi-VN", { timeZone: "Asia/Ho_Chi_Minh" });
        }
    }
    return stringifyValue(value);
}
function stringifyValue(value) {
    if (Array.isArray(value))
        return value.map(String).join(", ");
    if (typeof value === "object")
        return JSON.stringify(value);
    return String(value);
}
export function buildChoiceBreakdown(field, counts, totalResponses) {
    const countMap = counts || {};
    const options = Array.isArray(field.options) ? field.options : [];
    const knownIds = new Set();
    const items = options.map((opt) => {
        const id = String(opt.id);
        knownIds.add(id);
        const count = Number(countMap[id] || 0);
        return {
            id,
            label: opt.label,
            count,
            percent: totalResponses > 0 ? Math.round((count / totalResponses) * 100) : 0,
        };
    });
    Object.keys(countMap).forEach((id) => {
        if (knownIds.has(id))
            return;
        const count = Number(countMap[id] || 0);
        if (count <= 0)
            return;
        items.push({
            id,
            label: id,
            count,
            percent: totalResponses > 0 ? Math.round((count / totalResponses) * 100) : 0,
        });
    });
    return items.sort((a, b) => b.count - a.count);
}
export function formatFormResponseSubmittedAt(value) {
    if (!value)
        return "—";
    const d = new Date(String(value).replace(" ", "T"));
    if (Number.isNaN(d.getTime()))
        return String(value);
    const pad = (n) => String(n).padStart(2, "0");
    return `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())} ${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
}
export function buildFormResponseComposeText(row, definition) {
    const lines = [];
    const user = row.user || {};
    lines.push(`Người gửi: ${user.fullname || "—"}`);
    lines.push(`Email: ${user.email || "—"}`);
    lines.push(`Thời gian: ${formatFormResponseSubmittedAt(row.submitted_at)}`);
    getInputFields(definition).forEach((field) => {
        const label = field.label || field.id;
        const raw = row.answers ? row.answers[field.id] : undefined;
        lines.push(`${label}: ${formatAnswerValue(field, raw)}`);
    });
    return lines.join("\n");
}
export function ratingDistribution(field, responses) {
    const fieldId = field.id;
    const max = field.max || 5;
    const counts = {};
    for (let i = 1; i <= max; i += 1)
        counts[i] = 0;
    let answered = 0;
    responses.forEach((row) => {
        const val = row.answers ? row.answers[fieldId] : null;
        if (val === null || val === undefined || val === "")
            return;
        const star = Math.round(Number(val));
        if (star >= 1 && star <= max) {
            counts[star] += 1;
            answered += 1;
        }
    });
    return Object.keys(counts)
        .map((key) => Number(key))
        .sort((a, b) => b - a)
        .map((star) => ({
        star,
        count: counts[star],
        percent: answered > 0 ? Math.round((counts[star] / answered) * 100) : 0,
    }));
}
